/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import { shadowColor } from 'theme/color';
import { Card, Grid } from '@mui/material';
import { fontsize24, poppins500 } from 'theme/common.style';
import ReactPlayer from 'react-player';

function PropertyAngleView(props) {
  return (
    <Card
      variant="outlined"
      style={{
        borderRadius: '8px',
        boxShadow: `0px 1px 8px ${shadowColor}`,
        padding: '30px 20px',
        marginTop: '14px',
      }}
    >
      <Grid>
        <Grid sx={{ ...poppins500, ...fontsize24 }}>360 Degree Tour</Grid>
        <Grid display="flex">
          <ReactPlayer
            width="1314px"
            height="739px"
            borderRadius="10px"
            controls
            url="https://www.youtube.com/watch?v=G8nNGk6LHaM"
          />
        </Grid>
      </Grid>
    </Card>
  );
}

PropertyAngleView.propTypes = {};

export default PropertyAngleView;
